import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.6_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/components/elements/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/learn-more/how-to-grow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/learn-more/order-process.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/igi_certificate.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/blue-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/halo-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/radiant-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/ring-box.jpg");
